import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { IdCard } from "lucide-react";

export default function PatientCard() {
  const { token } = useParams();
  const [card, setCard] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/public/patient-card/${token}`);
        setCard(data);
      } catch (e) {
        setErr(formatErr(e?.response?.data?.detail || "Card not found"));
      }
    })();
  }, [token]);

  if (err) return <div className="min-h-screen flex items-center justify-center text-slate-500 p-6 text-center">{err}</div>;
  if (!card) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="max-w-sm w-full bg-white border border-slate-200 rounded-3xl shadow-sm p-8 text-center">
        <IdCard size={48} className="mx-auto text-blue-700" />
        <div className="text-xs uppercase tracking-[0.3em] text-slate-400 mt-4">Patient Card</div>
        <h1 className="text-2xl font-extrabold text-slate-900 mt-2" style={{ fontFamily: "Work Sans" }}>{card.full_name}</h1>
        {card.patient_number ? <div className="text-sm text-slate-500 mt-1 font-mono">{card.patient_number}</div> : null}
        <div className="mt-5 rounded-xl bg-slate-50 border border-slate-200 p-3 text-sm text-slate-600">{card.hospital_name}</div>
        <p className="mt-4 text-xs text-slate-500">Present this card at reception for faster check-in.</p>
      </div>
    </div>
  );
}
